import { inject, Injectable, InjectionToken } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { saveAs as fileSaverSaveAs } from 'file-saver';
import { AppHttpClientApi } from '@helpers/api/http-client-api';
import { APP_CONFIG, AppConfig } from '@cfg/env/app.config';
import { Observable, of, map } from 'rxjs';
import { MOCK_BASE64 } from '@helpers/api/mocks/base64.mock';

export const SAVE_AS = new InjectionToken<
  (data: Blob, fileName: string) => void
>('SAVE_AS', {
  providedIn: 'root',
  factory: () => (data: Blob, fileName: string) =>
    fileSaverSaveAs(data, fileName)
});

@Injectable({
  providedIn: 'root'
})
export class FileDownloadService {
  private readonly http = inject(AppHttpClientApi);
  private readonly appConfig: AppConfig = inject(APP_CONFIG);
  private readonly saveAsFn = inject(SAVE_AS);
  private readonly downloadResource = 'cargamasivaemp/file';
  private readonly mockBase64Excel = MOCK_BASE64;

  /**
   * Obtiene el archivo en base64 desde backend o mock
   */
  getBase64(operationType: string, policyNumber: string): Observable<string> {
    if (this.appConfig.useMocks) {
      return of(this.mockBase64Excel);
    }

    const params = new HttpParams()
      .set('operationType', operationType)
      .set('policyNumber', policyNumber);
    const url = `${this.downloadResource}?${params.toString()}`;
    return this.http
      .getPlain<{ annotatedFileBase64: string }>(url)
      .pipe(map((response) => response?.annotatedFileBase64 ?? ''));
  }

  /**
   * Convierte base64 a Blob
   */
  private base64ToBlob(base64: string, contentType: string): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  /**
   * Descarga el archivo (CSV)
   */
  downloadFile(base64: string, fileName: string): void {
    const blob = this.base64ToBlob(base64, 'text/csv;charset=utf-8');

    this.saveAsFn(blob, fileName);
  }
}
